import React from 'react';

const Benefit = ({ title, description, icon }) => (
  <div className="benefit">
    <div className="benefit__icon">
      {icon && <i className={`fal ${icon} fa--benefit-icon`} />}
    </div>
    <div className="benefit__copy">
      <span className="benefit__title">{title}</span>
      <p>{description}</p>
    </div>
  </div>
);

export default Benefit;
